import React, { memo, useMemo } from 'react';
import DynamicLoader from 'routes/DynamicLoader';

import { isNonEmptyObject } from 'utils/helpers.util';

import useStepsProgress from 'pages/Checkout/hooks/useStepsProgress.hook';

import useUser from 'services/user/hooks/useUser.hook';

import useDeliverTo from '../../hooks/useDeliverTo.hook';
import useDeliverToStatus from '../../hooks/useDeliverToStatus.hook';

import useScreen from '../../hooks/useScreen.hook';
import DeliveryLayout from '../DeliveryLayout';

const DeliverToDrawer = DynamicLoader(() =>
  import(/* webpackChunkName: "DeliverToDrawer" */ '../DeliverToDrawer')
) as any;
const DeliverToNonLocationCX = () => {
  // Retrieves user's address; passing "false" so it wont call the API again
  const [userState, defaultAddress, sessionAreaMatchedUserAddr] = useUser(false);

  const [{ isCartList }] = useScreen();
  // Steps setter
  const [{ deliverTo }, { setStepDeliverToStatus }] = useStepsProgress();

  // Delivery main hook
  const [deliverToState, { deliverToPutAddress }] = useDeliverTo(
    defaultAddress,
    sessionAreaMatchedUserAddr
  );
  useDeliverToStatus(deliverTo, deliverToState, setStepDeliverToStatus);

  // Reusable variable checks
  const currentlySelectedAddress = useMemo(() => {
    if (isNonEmptyObject(sessionAreaMatchedUserAddr)) {
      return sessionAreaMatchedUserAddr;
    }
    if (isNonEmptyObject(defaultAddress)) {
      return defaultAddress;
    }
    return userState.addresses[0];
  }, [sessionAreaMatchedUserAddr, defaultAddress, userState]);

  const { loading } = userState.add || { loading: false };
  const { error, loading: deliverToStateLoading } = deliverToState;
  return (
    <>
      <DeliveryLayout
        error={error}
        addressDetails={currentlySelectedAddress}
        loading={deliverToStateLoading || loading}
      />

      {isCartList && (
        <DeliverToDrawer deliverToState={deliverToState} onProceedHandler={deliverToPutAddress} />
      )}
    </>
  );
};

export default memo(DeliverToNonLocationCX);
